import {
  matchChatMessagePending,
  matchChatMessageRejected,
  matchChatStatusReceived,
} from '../../redux/reducers/privateStateReducer/matchChatActions';

// Служебные сообщения сервера о модерируемом чате ИИ-матча (см. контракт в
// configs/matchChat.js). Одобренное сообщение сюда не относится — оно
// приходит обычным ADD_CHAT_MESSAGE с серверной меткой
export const MATCH_CHAT_SERVER_MESSAGE_TYPES = {
  // Отправителю: сообщение принято в очередь модератора
  PENDING: 'CHAT_MESSAGE_PENDING',
  // Отправителю: сообщение не доставлено
  REJECTED: 'CHAT_MESSAGE_REJECTED',
  // Всем: чат на паузе или снова работает
  STATUS: 'CHAT_STATUS',
};

const toId = (value) => (typeof value === 'string' && value ? value : null);
const toFiniteNumber = (value) => (typeof value === 'number' && Number.isFinite(value) ? value : null);

/**
 * Разбор сообщения матчевого сокета о чате ИИ-матча (LobbyPage.onmessage,
 * до общей ветки applyRelayedServerAction). Сырые сообщения сервера в стор
 * не попадают — их переводят в приватные экшены matchChat.
 *
 * Сообщения без clientMessageId ни к одной строке не относятся — их тоже
 * считаем разобранными: в общий стор им дороги нет.
 *
 * @param {Object} msg - разобранное сообщение сокета
 * @param {Function} dispatch
 * @param {Object} [options]
 * @param {number} [options.now] - часы клиента в момент приема
 * @returns {boolean} сообщение о чате (разобрано здесь)
 */
export const applyMatchChatServerMessage = (msg, dispatch, {now = Date.now()} = {}) => {
  const payload = msg?.payload && typeof msg.payload === 'object' ? msg.payload : {};
  switch (msg?.type) {
    case MATCH_CHAT_SERVER_MESSAGE_TYPES.PENDING: {
      const clientMessageId = toId(payload.clientMessageId);
      if (clientMessageId) {
        dispatch(matchChatMessagePending({
          clientMessageId,
          messageId: toId(payload.messageId),
          receivedAt: now,
        }));
      }
      return true;
    }
    case MATCH_CHAT_SERVER_MESSAGE_TYPES.REJECTED: {
      dispatch(matchChatMessageRejected({
        clientMessageId: toId(payload.clientMessageId),
        messageId: toId(payload.messageId),
        reason: typeof payload.reason === 'string' ? payload.reason : null,
        moderatorReason: typeof payload.moderatorReason === 'string' ? payload.moderatorReason : null,
        retryAfterMs: toFiniteNumber(payload.retryAfterMs),
        receivedAt: now,
      }));
      return true;
    }
    case MATCH_CHAT_SERVER_MESSAGE_TYPES.STATUS:
      dispatch(matchChatStatusReceived({isPaused: payload.isPaused === true}));
      return true;
    default:
      return false;
  }
};
